import { motion } from "framer-motion";
import { ALL_TRADES } from "../lib/site-data";

const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/27hpml8n_Pic%20%601%20%281%29.png";

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-16 lg:py-24"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image — sticky on desktop */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-24"
          >
            <div className="relative overflow-hidden rounded-lg border border-white/5">
              <img
                src={ABOUT_IMAGE}
                alt="Modern interior with wooden sideboard and pendant lights"
                className="w-full h-full object-cover aspect-[4/5]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1f2935]/30 to-transparent pointer-events-none" />
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-8 bg-[#D4AF37]" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
                Who we are
              </span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.05]">
              Crafted flooring,
              <br />
              <span className="text-[#D4AF37]">built to last.</span>
            </h2>

            <div className="mt-8 space-y-5 max-w-2xl">
              <p className="text-base sm:text-[17px] text-slate-300 leading-[1.75]">
                At DN Flooring, we are committed to delivering exceptional
                flooring solutions that combine craftsmanship, durability, and
                refined design. Built on a foundation of hands-on experience
                and attention to detail, our company specializes in
                professional flooring installation, subfloor preparation, and
                finish work tailored to meet the unique needs of every client.
                We understand that flooring is one of the most important
                elements of any space—it sets the tone, enhances functionality,
                and adds long-term value. That's why we approach every project
                with precision, using high-quality materials and proven
                installation methods to ensure a flawless and lasting result.
              </p>
              <p className="text-base sm:text-[17px] text-slate-300 leading-[1.75]">
                Our team takes pride in maintaining a clean, organized, and
                efficient work environment from start to finish. From initial
                consultation to final walkthrough, we prioritize clear
                communication, transparency, and customer satisfaction. Whether
                we are working on residential homes or commercial properties,
                we treat every project with the same level of care and
                professionalism. At DN Flooring, our goal is not only to meet
                expectations, but to exceed them—delivering results that stand
                out for their quality, reliability, and attention to detail. We
                believe in building long-term relationships with our clients by
                providing dependable service and flooring solutions they can
                trust for years to come.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-white/10">
              <h3 className="text-[11px] uppercase tracking-[0.28em] text-slate-400 mb-5">
                What we handle
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2.5">
                {ALL_TRADES.map((t) => (
                  <div
                    key={t}
                    className="flex items-center gap-2 text-[14px] text-slate-300"
                    data-testid={`trade-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    <span className="h-1 w-1 rounded-full bg-[#D4AF37] flex-shrink-0" />
                    {t}
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
